<template>
  <v-card>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="4">
          <p class="text-caption">Edit value or paste a column of values into first cell</p>
        </v-col>
        <v-spacer />
        <v-col>
          <v-tooltip top>
            <template #activator="{ on }">
              <v-btn width="90" height="30" small v-on="on" @click="copyValues('r')" outlined>
                <v-icon small>mdi-content-copy</v-icon>
                Row
              </v-btn>
            </template>
            <span>Copy values as row</span>
          </v-tooltip>
        </v-col>
        <v-spacer />
        <v-col>
          <v-tooltip top>
            <template #activator="{ on }">
              <v-btn width="90" height="30" small v-on="on" @click="copyValues('c')" outlined>
                <v-icon small>mdi-content-copy</v-icon>
                Column
              </v-btn>
            </template>
            <span>Copy values as column</span>
          </v-tooltip>
        </v-col>
        <v-spacer />
        <v-col>
          <v-tooltip top>
            <template #activator="{ on }">
              <v-btn width="90" height="30" small v-on="on" @click="pasteValues" outlined>
                <v-icon small>mdi-content-paste</v-icon>
                Paste
              </v-btn>
            </template>
            <span>Paste values as column</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-simple-table dense>
        <template #default>
          <thead>
            <tr>
              <th class="text-left">Year</th>
              <th class="text-left">Value</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rIndex) in tableValue" :key="rIndex">
              <template v-if="Array.isArray(row)">
                <td>{{ row[0] }}</td>
                <td>
                  <v-text-field
                    type="number"
                    v-model="row[1]"
                    @input="parseValue($event, rIndex)"
                    :ref="`val-row-${rIndex}`"
                    dense
                    hide-details
                    hide-spin-buttons
                    variant="plain"
                  />
                </td>
              </template>
              <td v-else>{{ row }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn text color="primary" @click="cancel()">Cancel</v-btn>
      <v-btn text color="primary" @click="save()">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { deepClone } from "@/plugins/utils";

export default {
  name: "InputTable",
  components: {},
  mixins: [],
  props: {
    value: { type: Array, required: true },
    isDialogOpen: { type: Boolean, required: true },
    num_years: { type: Number, required: false, default: 2 },
    startYear: { type: Number, required: false, default: null },
  },
  data() {
    return {
      originalValue: undefined,
    };
  },
  computed: {
    textValue: {
      get() {
        return this.arrayToString(this.value);
      },
      set(val) {
        const valueCopy = this.value;
        valueCopy.splice(
          0,
          this.num_years,
          ...val
            .split("\n")
            .slice(0, this.num_years)
            .map((v) => Number(v))
        );

        this.$emit("input", valueCopy);
        this.$emit("change");
      },
    },
    tableValue() {
      const defaultArray = [...Array(this.num_years).keys()].map((v) => [
        `${this.startYear ? this.startYear + v : `Year ${v + 1}`} `,
        " ",
      ]);
      if (this.textValue) {
        const parsedPasted = this.textValue.split("\n").map((v) => v.split("	"));
        return defaultArray.map((v, i) => [
          v[0],
          ...(i < parsedPasted.length ? parsedPasted[i] : []),
        ]);
      }
      return defaultArray;
    },
  },
  watch: {
    isDialogOpen(val) {
      if (val) {
        this.originalValue = deepClone(this.value);
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.originalValue = deepClone(this.value);
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    copyValues(formation) {
      const copyValues = this.tableValue.map((el) => el[1]);
      const excelData = copyValues.join(formation === "r" ? "\t" : "\n");
      navigator.clipboard.writeText(excelData);
    },
    pasteValues() {
      navigator.clipboard.readText().then((clipText) => {
        const retrievedValues = clipText.split("\n").filter((number) => number.length > 0);
        if (retrievedValues.length > 0 && retrievedValues.every((e) => !Number.isNaN(Number(e)))) {
          const valueCopy = this.value;
          // To avoid pasting a "" as a 0.
          const newValues = [
            ...retrievedValues,
            ...valueCopy.slice(retrievedValues.length, valueCopy.length),
          ];
          this.textValue = this.arrayToString(newValues);
        }
      });
    },
    arrayToString(array) {
      return array.slice(0, this.num_years).toString().replace(/,/g, "\n");
    },
    cancel() {
      this.textValue = this.arrayToString(this.originalValue);
      this.$emit("close-dialog");
    },
    save() {
      this.$emit("close-dialog");
    },
    parseValue(input, index) {
      const valueCopy = this.value;
      valueCopy.splice(index, 1, input);
      this.textValue = valueCopy.join("\n");
    },
  },
};
</script>

<style scoped>
.table {
  border-spacing: 5px;
}
</style>
